import type { GPACalculationResult } from '@gpa-scales/shared-types';
import type { StateCreator } from 'zustand';

export interface ResultsSlice {
  result: GPACalculationResult | null;
  isCalculating: boolean;
}

export const createResultsSlice: StateCreator<ResultsSlice> = () => ({
  result: null,
  isCalculating: false,
});
